import { render, staticRenderFns } from "./PurchaseNav.vue?vue&type=template&id=391d1765&scoped=true&"
import script from "./PurchaseNav.vue?vue&type=script&lang=js&"
export * from "./PurchaseNav.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseNav.vue?vue&type=style&index=0&id=391d1765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d1765",
  null
  
)

export default component.exports